/**
 * DevExtreme (esm/ui/scheduler/classes.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var FIXED_CONTAINER_CLASS = "dx-scheduler-fixed-appointments";
export var REDUCED_APPOINTMENT_CLASS = "dx-scheduler-appointment-reduced";
export var REDUCED_APPOINTMENT_ICON = "dx-scheduler-appointment-reduced-icon";
export var RECURRENCE_APPOINTMENT_CLASS = "dx-scheduler-appointment-recurrence";
export var EMPTY_APPOINTMENT_CLASS = "dx-scheduler-appointment-empty";
export var ALL_DAY_APPOINTMENT_CLASS = "dx-scheduler-all-day-appointment";
export var REDUCED_APPOINTMENT_PARTS_CLASSES = {
    head: "dx-scheduler-appointment-head",
    body: "dx-scheduler-appointment-body",
    tail: "dx-scheduler-appointment-tail"
};
export var DIRECTION_APPOINTMENT_CLASSES = {
    horizontal: "dx-scheduler-appointment-horizontal",
    vertical: "dx-scheduler-appointment-vertical"
};
export var APPOINTMENT_DRAG_SOURCE_CLASS = "dx-scheduler-appointment-drag-source";
export var APPOINTMENT_ITEM_CLASS = "dx-scheduler-appointment";
export var APPOINTMENT_CONTENT_CLASSES = {
    APPOINTMENT_CONTENT_DETAILS: "dx-scheduler-appointment-content-details",
    RECURRING_ICON: "dx-scheduler-appointment-recurrence-icon",
    APPOINTMENT_TITLE: "dx-scheduler-appointment-title",
    APPOINTMENT_DATE: "dx-scheduler-appointment-content-date",
    ALL_DAY_CONTENT: "dx-scheduler-appointment-content-allday",
    ITEM: "dx-scheduler-appointment",
    AGENDA_MARKER: "dx-scheduler-agenda-appointment-marker",
    AGENDA_RESOURCE_LIST: "dx-scheduler-appointment-resource-list",
    AGENDA_RESOURCE_LIST_ITEM: "dx-scheduler-appointment-resource-item",
    AGENDA_RESOURCE_LIST_ITEM_VALUE: "dx-scheduler-appointment-resource-item-value"
};
export var AGENDA_LAST_IN_DATE_APPOINTMENT_CLASS = "dx-scheduler-last-in-date-agenda-appointment";
export var HEADER_CURRENT_TIME_CELL_CLASS = "dx-scheduler-header-panel-current-time-cell";
export var VIRTUAL_CELL_CLASS = "dx-scheduler-virtual-cell";
export var TIME_PANEL_CLASS = "dx-scheduler-time-panel";
export var DATE_TABLE_CLASS = "dx-scheduler-date-table";
export var DATE_TABLE_ROW_CLASS = "dx-scheduler-date-table-row";
export var GROUP_ROW_CLASS = "dx-scheduler-group-row";
export var GROUP_HEADER_CONTENT_CLASS = "dx-scheduler-group-header-content";
export var LAST_GROUP_CELL_CLASS = "dx-scheduler-last-group-cell";
export var FIRST_GROUP_CELL_CLASS = "dx-scheduler-first-group-cell";
export var VERTICAL_GROUP_COUNT_CLASSES = ["dx-scheduler-group-column-count-one", "dx-scheduler-group-column-count-two", "dx-scheduler-group-column-count-three"];
